import ActionTypes from '@ziynx/action-types';

const initialState = {};

export default function reduceCompanies(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  const groupStatement = state[action?.id] ?? {};

  switch (action.type) {
  case ActionTypes.company.post.START:
  case ActionTypes.company.get.START:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...groupStatement,
          fetching: false,
          success: false,
          error: null,
          patching: false,
          checking: true,
        },
      },
    };
  case ActionTypes.company.patch.START:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...groupStatement,
          fetching: true,
          success: false,
          error: null,
          patching: true,
          checking: false,
        },
      },
    };

  case ActionTypes.company.patchImage.START:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        patching: true,
        patchedImage: false,
      },
    };

  case ActionTypes.company.post.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
        // Refresh token to resolve issues with cognito groups
        // in create company lambda
        refreshToken: true,
      },
    };
  case ActionTypes.company.get.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        patching: false,
        patchSuccess: false,
        checking: false,
        error: null,
      },
    };
  case ActionTypes.company.patch.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
        patching: false,
        patchSuccess: true,
        checking: false,
        refreshToken: false,
      },
    };

  case ActionTypes.company.patchImage.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        ...(action?.response ?? {}),
        patching: false,
        patchedImage: true,
      },
    };

  case ActionTypes.company.post.ERROR:
  case ActionTypes.company.get.ERROR:
  case ActionTypes.company.patch.ERROR:
    return {
      ...state,
      ...{
        ...groupStatement,
        success: false,
        fetching: false,
        error: action?.error,
      },
    };

  case ActionTypes.company.reset:
    return {
      ...state,
      [action?.id]: {
        ...groupStatement,
        patching: false,
        patchSuccess: false,
        patchedImage: false,
        success: false,
      },
    };
      // no default
  }
  return state;
}
